import styled from 'styled-components';

import { TClearSlotProps } from '@/shared/components/ui/searchbar/searchbar.types';

// Always mounted so the input keeps its size when the clear button appears.
export const ClearSlot = styled.span<TClearSlotProps>`
  display: flex;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
